import vxlColors from 'shared/styles/color/core';

const border = {
  primary: '#001c2d24',
  primarySolid: vxlColors.core.neutrals.grey[200],
  focused: vxlColors.core.purple[900],
  focusedInverse: vxlColors.core.purple[100],
  emphasized: vxlColors.core.neutrals.black,
};

export default border;
